// Stylesheets
import './assets/scss/site.scss';

import { hover } from './assets/modules/hover';
import { trigger } from './assets/modules/trigger';
import { fluidvideo } from './assets/modules/fluidvideo';
import { popup } from './assets/modules/popup';
import { modal } from './assets/modules/modal';
import { copyUrl } from './assets/modules/copyUrl';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe-init';
import { stickySidebarFunc } from './assets/modules/stickySidebar';
import { momijiLogoAnim } from './assets/modules/momijiLogoAnim';
import { accordion } from './assets/modules/accordion';
import { momijiMap } from './assets/modules/momijimap';
import { letterFadeAnimate } from './assets/modules/letterFadeAnimate';
import { formSelect } from './assets/modules/formSelect';

const init = () => {
  hover();
  trigger();
  fluidvideo();
  popup();
  modal();
  copyUrl();
  initPhotoSwipeFromDOM('.js-pswp-container');
  stickySidebarFunc();
  momijiLogoAnim();
  accordion();
  momijiMap();
  letterFadeAnimate();
  formSelect();
}

init();